<template>
    <div id="top-bar">
        <span class="big-text"> Game Stage: <span style="color:var(--team-red);"> {{ gameStage }} </span> </span>
        <span> Turn Player: <span :style="{color: `var(--team-${gameStatus.turnPlayer})`}"> {{ teamName }} </span> </span>
        <span> Current Turn: {{ gameStatus.turnNumber }} </span>
    </div>
</template>

<script>
import {gameStageTitles} from '../../scripts/GameVariables.js';
export default {
    computed: {
        gameStage(){
            return gameStageTitles[this.gameStatus.gameStage];
        },
        teamName(){
            return this.gameStatus.turnPlayer === 'red' ? 'Red' : 'Blue';
        }
    },
    props: {
        gameStatus: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
#top-bar{
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: auto;
    margin-right: auto;
    background: white;
    width: 500px;
    padding-left: 10px;
    border-radius: 5px;
    transition: all 1s;
}
#top-bar:hover{
    width: 600px;
}
#top-bar span{
    margin-right: 10px;
}
.big-text{
    font-size: 1.05em;
}
</style>